module.exports = __webpack_public_path__ + "img/bg_app_logo.27da17e2.svg";